import { render, staticRenderFns } from "./EndScreen.vue?vue&type=template&id=4c065088&scoped=true&"
import script from "./EndScreen.vue?vue&type=script&lang=js&"
export * from "./EndScreen.vue?vue&type=script&lang=js&"
import style0 from "./EndScreen.vue?vue&type=style&index=0&id=4c065088&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c065088",
  null
  
)

export default component.exports